import { Injectable } from '@angular/core';
import { Action, Actions, Selector, State, StateContext, Store } from '@ngxs/store';
import produce from 'immer';
import { Observable } from 'rxjs';
import { AgentListBrickSettingRemoteDto, BrickSettingsService } from '../../../../../../../generated/swagger';
import { IBrickSettingStateModel, SpecificBrickSettingsStateBase } from '../specific-brick-settings-base';
import { ChangeGroupsForAgentList, ChangeShowOwnAgent } from './agent-list-setting.actions';

export interface AgentListSettingsStateModel extends IBrickSettingStateModel<AgentListBrickSettingRemoteDto> {}

function getDefaultSpecificBrickSetting(): AgentListBrickSettingRemoteDto {
   return {
      showOwnAgent: true,
      commonBrickSettingRemoteDto: null,
   };
}

@Injectable()
@State<AgentListSettingsStateModel>({
   name: 'agentListBrickSetting',
   defaults: {
      specificBrickSettings: {
         brickSettings: {},
         brickSettingsEditMode: null,
      },
   },
})
export class AgentListSettingState extends SpecificBrickSettingsStateBase<AgentListBrickSettingRemoteDto>(getDefaultSpecificBrickSetting) {
   constructor(private brickSettingsService: BrickSettingsService, store: Store, actions$: Actions) {
      super(store);
   }

   @Selector([AgentListSettingState, AgentListSettingState.getSettingModelFn])
   public static getIsShowOwnAgentEnabled(state, getSettingModelFn: (state, brickInstanceId) => AgentListBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showOwnAgent;
      };
   }

   // Shows Groups of current logged in User?
   @Selector([AgentListSettingState, AgentListSettingState.getSettingModelFn])
   public static getGroupIdsForAgentList(state, getSettingModelFn: (state, brickInstanceId) => AgentListBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showAgentsFromGroup;
      };
   }

   @Action(ChangeShowOwnAgent)
   public changeShowOwnAgent(ctx: StateContext<AgentListSettingsStateModel>, action: ChangeShowOwnAgent) {
      const state = produce(ctx.getState(), (draft) => {
         const brickSettingModel = AgentListSettingState.getSettingModelOrDefault(draft, action.brickInstanceId);
         brickSettingModel.showOwnAgent = action.showOwnAgent;
         draft.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
      });
      ctx.setState(state);
   }

   @Action(ChangeGroupsForAgentList)
   public changeGroupsForAgentList(ctx: StateContext<AgentListSettingsStateModel>, action: ChangeGroupsForAgentList) {
      const state = produce(ctx.getState(), (draft) => {
         const brickSettingModel = AgentListSettingState.getSettingModelOrDefault(draft, action.brickInstanceId);
         brickSettingModel.showAgentsFromGroup = action.groupIdsForAgentList;
         draft.specificBrickSettings.brickSettingsEditMode[action.brickInstanceId] = brickSettingModel;
      });
      ctx.setState(state);
   }

   protected doSaveSpecificSettings(brickInstanceId: string, brickSetting: AgentListBrickSettingRemoteDto): Observable<any> {
      return this.brickSettingsService.changeAgentListBrickSettings({
         brickInstanceId: brickInstanceId,
         settings: brickSetting,
      });
   }
}
